<div class="quill-toolbar-outer-wrapper" [class.has-scroll-buttons]="showScrollButtons()">
  @if (showScrollButtons()) {
    <button class="scroll-btn left-btn" mat-icon-button (mousedown)="$event.preventDefault()" (click)="scrollToolbar('left')">
      <mat-icon>chevron_left</mat-icon>
    </button>
  }

  <div id="custom-toolbar" #toolbarContainer>
    <span class="ql-formats">
      <button class="ql-bold" mat-icon-button [matTooltip]="'Quill.Tooltip.Bold' | translate"></button>
      <button class="ql-italic" mat-icon-button [matTooltip]="'Quill.Tooltip.Italic' | translate"></button>
      <button class="ql-underline" mat-icon-button [matTooltip]="'Quill.Tooltip.Underline' | translate"></button>
      <button class="ql-strike" mat-icon-button [matTooltip]="'Quill.Tooltip.Strikethrough' | translate"></button>
      <button class="ql-code" mat-icon-button [matTooltip]="'Quill.Tooltip.Code' | translate"></button>
    </span>
    <span class="ql-formats">
      <button class="ql-blockquote" mat-icon-button [matTooltip]="'Quill.Tooltip.Blockquote' | translate"></button>
    </span>
    <span class="ql-formats">
      <button class="ql-list" value="ordered" mat-icon-button [matTooltip]="'Quill.Tooltip.OrderedList' | translate"></button>
      <button class="ql-list" value="bullet" mat-icon-button [matTooltip]="'Quill.Tooltip.BulletedList' | translate"></button>
      <button class="ql-indent" value="-1" mat-icon-button [matTooltip]="'Quill.Tooltip.DecreaseIndent' | translate"></button>
      <button class="ql-indent" value="+1" mat-icon-button [matTooltip]="'Quill.Tooltip.IncreaseIndent' | translate"></button>
    </span>

    <!-- Size / Header / Font -->
    <span class="ql-formats">
      <div class="toolbar-dropdown">
        <button mat-icon-button (mousedown)="$event.preventDefault()" (click)="togglePanel('size')" [matTooltip]="'Quill.Tooltip.Size' | translate">
          <mat-icon>{{ currentSizeIcon }}</mat-icon>
        </button>
        @if (activePanel() === 'size') {
          <div class="dropdown-panel format-panel" (mousedown)="$event.preventDefault()">
            @for (item of formatSizeItems; track item.text) {
              <button class="dropdown-item" (click)="applyFormat('size', item.id)">
                <mat-icon>{{ item.icon }}</mat-icon>
                <span>{{ item.text | translate }}</span>
              </button>
            }
          </div>
        }
      </div>
      <div class="toolbar-dropdown">
        <button mat-icon-button (mousedown)="$event.preventDefault()" (click)="togglePanel('header')" [matTooltip]="'Quill.Tooltip.Header' | translate">
          <mat-icon>{{ currentHeaderIcon }}</mat-icon>
        </button>
        @if (activePanel() === 'header') {
          <div class="dropdown-panel format-panel" (mousedown)="$event.preventDefault()">
            @for (item of formatHeaderItems; track item.text) {
              <button class="dropdown-item" (click)="applyFormat('header', item.id)">
                <mat-icon>{{ item.icon }}</mat-icon>
                <span>{{ item.text | translate }}</span>
              </button>
            }
          </div>
        }
      </div>
      <div class="toolbar-dropdown">
        <button mat-icon-button (mousedown)="$event.preventDefault()" (click)="togglePanel('font')" [matTooltip]="'Quill.Tooltip.Font' | translate">
          <mat-icon>{{ currentFontIcon }}</mat-icon>
        </button>
        @if (activePanel() === 'font') {
          <div class="dropdown-panel format-panel" (mousedown)="$event.preventDefault()">
            @for (item of formatFontItems; track item.text) {
              <button class="dropdown-item" (click)="applyFormat('font', item.id)">
                <mat-icon>{{ item.icon }}</mat-icon>
                <span>{{ item.text | translate }}</span>
              </button>
            }
          </div>
        }
      </div>
    </span>

    <!-- Color / Background -->
    <span class="ql-formats">
      <div class="toolbar-dropdown">
        <button mat-icon-button (mousedown)="$event.preventDefault()" (click)="togglePanel('color')" [matTooltip]="'Quill.Tooltip.TextColor' | translate">
          <mat-icon [style.color]="currentColor">format_color_text</mat-icon>
        </button>
        @if (activePanel() === 'color') {
          <div class="dropdown-panel color-panel" (mousedown)="$event.preventDefault()">
            <div class="color-grid">
              @for (color of colorPalette; track color) {
                <div class="color-swatch" [style.background-color]="color" (click)="applyFormat('color', color)" [matTooltip]="color"></div>
              }
            </div>
            <button class="dropdown-item clear-btn" (click)="applyFormat('color', false)">
              <mat-icon>format_clear</mat-icon>
              <span>{{ 'Quill.Tooltip.ClearFormatting' | translate }}</span>
            </button>
          </div>
        }
      </div>
      <div class="toolbar-dropdown">
        <button mat-icon-button (mousedown)="$event.preventDefault()" (click)="togglePanel('background')" [matTooltip]="'Quill.Tooltip.BackgroundColor' | translate">
          <mat-icon [style.color]="currentBackground">format_color_fill</mat-icon>
        </button>
        @if (activePanel() === 'background') {
          <div class="dropdown-panel color-panel" (mousedown)="$event.preventDefault()">
            <div class="color-grid">
              @for (color of colorPalette; track color) {
                <div class="color-swatch" [style.background-color]="color" (click)="applyFormat('background', color)" [matTooltip]="color"></div>
              }
            </div>
            <button class="dropdown-item clear-btn" (click)="applyFormat('background', false)">
              <mat-icon>format_clear</mat-icon>
              <span>{{ 'Quill.Tooltip.ClearFormatting' | translate }}</span>
            </button>
          </div>
        }
      </div>
    </span>

    <!-- Alignment -->
    <span class="ql-formats">
      <div class="toolbar-dropdown">
        <button mat-icon-button (mousedown)="$event.preventDefault()" (click)="togglePanel('align')" [matTooltip]="'Quill.Tooltip.Alignment' | translate">
          <mat-icon>{{ currentAlignIcon }}</mat-icon>
        </button>
        @if (activePanel() === 'align') {
          <div class="dropdown-panel align-panel" (mousedown)="$event.preventDefault()">
            @for (item of alignmentItems; track item.icon) {
              <button mat-icon-button [matTooltip]="item.tooltipKey | translate" (click)="applyFormat('align', item.id)">
                <mat-icon>{{ item.icon }}</mat-icon>
              </button>
            }
          </div>
        }
      </div>
    </span>

    <span class="ql-formats">
      <button mat-icon-button (click)="convertToInlineFormula.emit()" [matTooltip]="'Quill.Tooltip.Formula' | translate">
        <mat-icon>calculate</mat-icon>
      </button>
      <button mat-icon-button (mousedown)="$event.preventDefault()" (click)="insertLink.emit()" [matTooltip]="'Quill.Tooltip.InsertLink' | translate">
        <mat-icon>link</mat-icon>
      </button>
      <button class="ql-clean" mat-icon-button (mousedown)="$event.preventDefault()" [matTooltip]="'Quill.Tooltip.ClearFormatting' | translate"></button>
    </span>

    @if (showChunkOptions) {
      <span class="ql-formats">
        @if (false) {
          <button mat-icon-button (click)="undo.emit()" [disabled]="!canUndo">
            <mat-icon [matTooltip]="'CreateChunk.Tooltip.Undo' | translate">undo</mat-icon>
          </button>
          <button mat-icon-button (click)="redo.emit()" [disabled]="!canRedo">
            <mat-icon [matTooltip]="'CreateChunk.Tooltip.Redo' | translate">redo</mat-icon>
          </button>
        }
        <button mat-icon-button (click)="copy.emit()">
          <mat-icon>content_copy</mat-icon>
        </button>
      </span>
    }
  </div>

  @if (showScrollButtons()) {
    <button class="scroll-btn right-btn" mat-icon-button (mousedown)="$event.preventDefault()" (click)="scrollToolbar('right')">
      <mat-icon>chevron_right</mat-icon>
    </button>
  }
</div>
